import { render, staticRenderFns } from "./VideoHotspot.vue?vue&type=template&id=24949763&scoped=true&"
import script from "./VideoHotspot.vue?vue&type=script&lang=js&"
export * from "./VideoHotspot.vue?vue&type=script&lang=js&"
import style0 from "./VideoHotspot.vue?vue&type=style&index=0&id=24949763&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24949763",
  null
  
)

component.options.__file = "VideoHotspot.vue"
export default component.exports